import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { Roles } from '@nrwl/rx-models';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { CommonModule } from '@angular/common';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxRoleGuardModule } from '@org/rx-directives';
import { MatActionList } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatListModule } from '@angular/material/list';
import { DragDropModule } from '@angular/cdk/drag-drop';

@Component({
  selector: 'nrwl-rx-expansion-panel',
  templateUrl: './rx-expansion-panel.component.html',
  styleUrls: ['./rx-expansion-panel.component.scss'],
  imports: [
    CommonModule,
    RxIconModule,
    RxRoleGuardModule,
    MatMenuModule,
    MatExpansionModule,
    MatActionList,
    MatActionList,
    MatGridListModule,
    MatListModule,
    DragDropModule,
  ],
  standalone: true,
})
export class RxExpansionPanelComponent implements OnInit, AfterViewInit {
  folder: string;

  @Input() id = 'item' + Math.random().toString(36).substring(2);
  @Input() icon = '';
  @Input() title = '';
  @Input() description = '';
  @Input() secondLine: string;
  @Output() opened: EventEmitter<any> = new EventEmitter();
  @Output() closed: EventEmitter<any> = new EventEmitter();
  @Output() expandClick: EventEmitter<any> = new EventEmitter();
  @Output() menuClicked: EventEmitter<any> = new EventEmitter();
  @Input() contentTemplate: TemplateRef<any>;
  @Input() contentContext: any;
  @Input() controlsTemplate: TemplateRef<any>; // RESERVED: Issue with cdkDragHandle, handle must be direct child, possible solution - cdk drag service

  @Input() showDragHandle: boolean;
  @Input() showMenuHandle: boolean;
  @Input() showExpandHandle: true;
  @Input() actionMenu: MatMenu;
  @Input() actionMenuContext: any;
  @Input() expanded: boolean;
  @Input() enableDrag: boolean;
  @Output() enableDragChange = new EventEmitter<boolean>();
  @Input() busy = false;
  @Input() rejectedRoles: Roles[] = [];
  @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef;

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {}

  onEnableDrag(state: boolean) {
    if (this.enableDrag !== state) {
      this.enableDrag = state;
      this.enableDragChange.emit(state);
    }
  }

  onOpened($event) {
    this.opened.emit($event);
  }

  onClosed($event) {
    this.closed.emit($event);
  }

  onExpandClick($event) {
    this.expandClick.emit($event);
  }
  onMenuClicked($event) {
    $event.stopPropagation();
    $event.preventDefault();
    this.menuClicked.emit();
  }
  onDragIconclick(event) {
    event.stopPropagation();
    event.preventDefault();
  }
  //to collapse panels on destroy
  ngOnDestroy(): void {
    this.expanded = false;
    // this.cdr.detectChanges()
  }
}
